module.exports = __webpack_public_path__ + "static/media/fb.37deb29d.svg";